import { render, staticRenderFns } from "./zhwy.vue?vue&type=template&id=31970160&scoped=true&"
import script from "./zhwy.vue?vue&type=script&lang=js&"
export * from "./zhwy.vue?vue&type=script&lang=js&"
import style0 from "./zhwy.vue?vue&type=style&index=0&id=31970160&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31970160",
  null
  
)

export default component.exports